//types
import {IOrganizationContact} from '@/utils/types';

export const initialValues: Omit<IOrganizationContact, 'added' | 'edited'> = {
	id: 0,
	email: '',
	firstName: '',
	lastName: '',
	phoneNumber: '',
	address: '',
	city: '',
	state: '',
	zip: '',
	meals: [],
};
